<template>
  <div class="toast-modal">
    <van-overlay
      :show="visible"
      @click="show = false"
      :lock-scroll="false"
      :z-index="200"
    >
      <div class="wrapper">
        <!-- 背景图 -->
        <div class="toast-bg">
          <!-- 内容区域 -->
          <div class="toast-content">
            <!-- 文本内容（支持多行） -->
            <div class="toast-text" v-html="message"></div>
            <!-- 按钮 -->
            <img
              :src="require('@/assets/imgs/promotionGift/toastBtn.png')"
              class="btn-img"
              @click="onConfirm"
            />
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'ToastModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.toast-modal {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .toast-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 375px;
    height: 404px;
    background: url('~@/assets/imgs/promotionGift/toastBg.png');
    background-size: contain;
    background-position: center;
    padding: 0;
    margin: 0;
  }
  .toast-content {
    .toast-text {
      width: 200px;
      margin-bottom: 40px;
      margin-top: 60px;
      white-space: pre-line; /* 支持换行 */
      text-align: center;
      font-size: 20px;
      line-height: 24px;
    }
    .btn-img {
      display: block;
      margin: auto;
      width: 150px;
      height: 42px;
      // height: auto;
      // filter: brightness(1.2);
    }
  }
}
</style>
